import React, { useState } from 'react';
import { useTheme } from 'react-jss';
import { slide as Menu } from 'react-burger-menu';

const getMenuStyles = ({ theme }) => ({
    bmBurgerButton: {
        position: 'absolute',
        width: 26,
        height: 20,
        left: 30,
        top: 40,
        zIndex: 19
    },
    bmBurgerBars: {
        background: theme.color.veryDarkGrayishBlue
    },
    bmBurgerBarsHover: {
        background: theme.color.darkRed
    },
    bmCrossButton: {
        display: 'none'
    },
    bmCross: {
        background: theme.color.grayishBlue3
    },
    bmMenuWrap: {
        height: '100%',
        zIndex: 30,
        boxShadow: '2px 5px 10px 5px rgb(0 0 0 / 10%)'
    },
    bmMenu: {
        background: 'rgb(238 233 242)',//theme.color.veryDarkGrayishBlue, '#fff'
        overflow: 'hidden'
    },
    bmItem: {
        outline: 'none',
        //display: "grid",
        //gridTemplateColumns: "80px 270px",
        height: "100%",
        '&:focus': {
            outline: 'none'
        }
    },
    bmMorphShape: {
        fill: theme.color.veryDarkGrayishBlue
    },
    bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 20
    },
});

function MenuComponent({ children, isMobile }) {
    const theme = useTheme();
    const menuStyles = getMenuStyles({ theme });
    const [isOpen, setIsOpen] = useState(true);
    return (
        <Menu
            isOpen={!isMobile && isOpen}
            noOverlay={!isMobile}
            disableCloseOnEsc
            styles={menuStyles}
            width={"250px"}
            //customBurgerIcon = {  true  }
        >
            {children}
        </Menu>
    );
}

export default MenuComponent;
